import { render, staticRenderFns } from "./call-center-call-back.vue?vue&type=template&id=39deb7b3"
import script from "./call-center-call-back.vue?vue&type=script&lang=ts"
export * from "./call-center-call-back.vue?vue&type=script&lang=ts"
import style0 from "./call-center-call-back.vue?vue&type=style&index=0&id=39deb7b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
